import { ApiError } from '../lib/ApiError'

export type RequestOptions = RequestInit & { plain?: boolean; raw?: boolean }

export class ApiService {
  static API_URL = import.meta.env.VITE_PUBLIC_API_URL ?? ''
  static DEFAULT_HEADERS = {
    'x-mydra-app': 'auth-web',
  }
  static accessToken = ''
  static headers = {}

  static async get(endpoint: string, fetchOptions?: RequestOptions) {
    const url = new URL(endpoint, ApiService.API_URL)

    const res = await fetch(url, {
      headers: {
        ...ApiService.DEFAULT_HEADERS,
        ...fetchOptions?.headers,
        ...ApiService.headers,
      },
      credentials: 'include',
      ...fetchOptions,
    })

    if (!res.ok) {
      let json
      try {
        json = await res.json()
      } catch {
        json = {}
      }

      throw new ApiError(json.message ?? res.statusText, res.status, json)
    }

    if (fetchOptions?.raw) {
      return res
    }

    return res.json()
  }

  static async post(
    endpoint: string,
    payload: unknown,
    fetchOptions?: RequestOptions
  ) {
    const url = new URL(endpoint, ApiService.API_URL)
    const isMultiPartFormData =
      payload instanceof FormData || payload instanceof File
    const res = await fetch(url, {
      method: 'POST',
      headers: {
        ...ApiService.DEFAULT_HEADERS,
        ...(isMultiPartFormData ? {} : { 'Content-Type': 'application/json' }),
        ...fetchOptions?.headers,
        ...ApiService.headers,
      },
      body: isMultiPartFormData ? payload : JSON.stringify(payload),
      credentials: 'include',
      ...fetchOptions,
    })

    if (!res.ok) {
      let json
      try {
        json = await res.json()
      } catch {
        json = {}
      }

      throw new ApiError(json.message ?? res.statusText, res.status, json)
    }

    if (fetchOptions?.plain) {
      return res.text()
    }

    return res.json()
  }

  static async patch(
    endpoint: string,
    payload: unknown,
    fetchOptions?: RequestOptions
  ) {
    const url = new URL(endpoint, ApiService.API_URL)
    const res = await fetch(url, {
      method: 'PATCH',
      headers: {
        ...ApiService.DEFAULT_HEADERS,
        'Content-Type': 'application/json',
        ...fetchOptions?.headers,
        ...ApiService.headers,
      },
      body: JSON.stringify(payload),
      credentials: 'include',
      ...fetchOptions,
    })

    if (!res.ok) {
      let json
      try {
        json = await res.json()
      } catch {
        json = {}
      }

      throw new ApiError(json.message ?? res.statusText, res.status, json)
    }
    return res.json()
  }

  static async put(
    endpoint: string,
    payload: unknown,
    fetchOptions?: RequestOptions
  ) {
    const url = new URL(endpoint, ApiService.API_URL)
    const isMultiPartFormData =
      payload instanceof FormData || payload instanceof File
    const res = await fetch(url, {
      method: 'PUT',
      headers: {
        ...ApiService.DEFAULT_HEADERS,
        ...(isMultiPartFormData ? {} : { 'Content-Type': 'application/json' }),
        ...fetchOptions?.headers,
        ...ApiService.headers,
      },
      body: isMultiPartFormData ? payload : JSON.stringify(payload),
      credentials: 'include',
      ...fetchOptions,
    })

    if (!res.ok) {
      let json
      try {
        json = await res.json()
      } catch {
        json = {}
      }

      throw new ApiError(json.message ?? res.statusText, res.status, json)
    }
    return res.json()
  }

  static setAccessToken(accessToken: string) {
    ApiService.accessToken = accessToken
  }

  static setHeader(headerName: string, headerValue) {
    ApiService.headers[headerName] = headerValue
  }
}
